const path = {
    sso: '/auth-sso'
}
export { path }